import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ClientLayout/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/app/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UnseenNotificationCountProvider"] */ "/app/src/contexts/UnseenNotificationCountContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebSocketProvider"] */ "/app/src/contexts/WebSocketContext.tsx");
